// Fixed-English defaults for the acceptance-mail dialog (D7, story #2776). These literals are
// business copy agreed with the client (GDELS), NOT UI labels: they must stay in English no
// matter the interface language, so this module intentionally never touches i18n/useSmartTranslation.
// The dialog still lets the user edit both fields before sending (RN4).

export const ACCEPTANCE_MAIL_DOCUMENT_TYPES = {
  FORM: 'FORM',
  SIGNED: 'SIGNED'
}

// S2 (FORM) / S24 (SIGNED) — `<FO>` = fabrication order code, `<vehículo>` = vehicle name,
// `<versión>` = acceptance version (attempt) being sent (#70 point 1: the version is part of the
// subject, so recipients can tell apart resends of successive versions of the same order).
export const buildAcceptanceMailDefaults = (documentType, fabricationOrderCode, vehicleName, versionNumber) => {
  const fo = fabricationOrderCode || ''
  const vehicle = vehicleName || ''
  const versionSuffix = versionNumber ? ` · Version ${versionNumber}` : ''

  if (documentType === ACCEPTANCE_MAIL_DOCUMENT_TYPES.SIGNED) {
    return {
      subject: `MoD — Signed acceptance · ${fo} / ${vehicle}${versionSuffix}`,
      body: `Please find attached the signed acceptance document for fabrication order ${fo} / vehicle ${vehicle}${versionNumber ? ` (version ${versionNumber})` : ''}.`
    }
  }

  return {
    subject: `MoD — Vehicle Inspection Protocol · ${fo} / ${vehicle}${versionSuffix}`,
    body: `Please find attached the Vehicle Inspection Protocol (MoD) for fabrication order ${fo} / vehicle ${vehicle}${versionNumber ? ` (version ${versionNumber})` : ''}.`
  }
}
